import React from 'react';
import LocalizedStrings from 'react-localization';
import { SetComponentLanguage } from '../../../helpers';
import en from './locales/en.json';
import fr from './locales/fr.json';

const strings = SetComponentLanguage(LocalizedStrings, en, fr);

const EventOptions = () => {
    return (
        strings.events.map((event, i) => <option key={i} value={event.value}>{event.name}</option>)
    )
}

export default EventOptions;


// WEBPACK FOOTER //
// ./src/components/Common/EventOptions/EventOptions.js